export const SAMPLE_GET_API_URL = '/api/v1/procurement/rfqs/listing';
